import React from 'react';

import Layout from 'components/Layout';
import ContentPendenciaDemanda from './ContentPendeciaDemanda';

const Pendencias = () => {
  return (
    <Layout>
      <ContentPendenciaDemanda />
    </Layout>
  );
};

export default Pendencias;
